import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CutOffDateState } from '@services/state/cut-off-date-state/cut-off-date.state';

@Component({
  selector: 'last-updated',
  standalone: true,
  template: `
    <div class="flex flex-col gap-2">
      <p>Last updated</p>
      <p class="flex h-10 items-center text-surface-700">{{ lastUpdated() ? lastUpdated() : '-' }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastUpdated {
  lastUpdated = inject(CutOffDateState).lastUpdated;
}
